import BooleanInput from './components/Boolean'
import DateInput from './components/Date'
import DateTimeInput from './components/DateTime'
import StringInput from './components/String'
import NumericInput from './components/Numeric'

import './styles.css'

// dictionary object for each and every input data type 
// accepted by a contact record

const TypedInputs = {
  BooleanInput,
  DateInput,
  DateTimeInput,
  StringInput,
  NumericInput
}

export default TypedInputs